export default "__VITE_ASSET__Bdt$pMEI__"